import type { QuestionnaireFrequency } from '@gcv/shared';
import { useMutation } from '@tanstack/react-query';

import { QuestionnairesApi } from 'api';
import { BANK_QUESTIONNAIRE_KEY } from '../../keys';
import { useUser } from '../../user';
import { useBankQuestionnaireCache } from '../useBankQuestionnaireCache';

export interface NewQuestionnaireParams {
  name: string;
  description: string;
  frequency: QuestionnaireFrequency;
  timeToRespond: number;
  reoccurring: boolean;
}

export function useCreateQuestionnaire() {
  const { userBankId } = useUser();
  const { addQuestionnaire } = useBankQuestionnaireCache();
  const questionnairesApi = new QuestionnairesApi();

  const { mutateAsync: createQuestionnaire, isPending: isCreateQuestionnairePending } = useMutation({
    mutationKey: [BANK_QUESTIONNAIRE_KEY],
    mutationFn: ({ name, description, frequency, timeToRespond, reoccurring }: NewQuestionnaireParams) =>
      questionnairesApi.addNewQuestionnaire(userBankId, {
        name,
        description,
        schedule: {
          reoccurring,
          frequency,
          time_to_respond: timeToRespond,
          reminder: 2
        }
      }),
    onSuccess: addQuestionnaire,
    meta: {
      snackbarErrorMessage: 'Could not create new questionnaire.'
    }
  });

  return { createQuestionnaire, isCreateQuestionnairePending };
}
